import React from "react";

export default function SignUp() {
  return <h1 className="log-out">Log Out</h1>;
}
